import type { AiPending } from "@/features/ai-agent/types/agent-step";
import type { Contact } from "@/features/contact/types";

type WithAiPending = Pick<Contact, "aiPending">;

export const hasPendingDraft = (contact: WithAiPending): boolean =>
  contact.aiPending?.draft != null;

export const pendingQuestionCount = (contact: WithAiPending): number =>
  contact.aiPending?.questions?.length ?? 0;

export const pendingApprovalCount = (contact: WithAiPending): number =>
  contact.aiPending?.approvals?.length ?? 0;

/** `aiPending` with one question answered, null once nothing is left, the way
 *  the backend's `syncPending` omits empty keys. */
export const withoutPendingQuestion = (
  aiPending: AiPending | null,
  stepId: string,
): AiPending | null => {
  if (!aiPending) return null;
  const questions = aiPending.questions?.filter(
    (question) => question.stepId !== stepId,
  );
  const next: AiPending = { ...aiPending, questions };

  if (!questions?.length) delete next.questions;

  return Object.keys(next).length > 0 ? next : null;
};
